import React from "react";
import { Title, Spinner } from "../../atoms";
import T from "prop-types";

export const ConfirmationContent = ({
  onCancel,
  onConfirm,
  title,
  content,
  contentDetail,
  subContent,
  rightBtnText,
  titleIcon,
  cancelText,
  titleClass,
  isLoading
}) => {
  return (
    <div
      style={{ background: "white", padding: 10, borderRadius: 4 }}
      id="confirmationDiv"
    >
      <div>
        <div className="boxImgDiv">
          <img src={titleIcon} />
          <Title text={title} className={titleClass} />
        </div>
        <Title text={content} className="boxContent text" />
        {contentDetail && <Title text={contentDetail} className="boxContent text" />}
        <Title text={subContent} className="boxContent text" />
      </div>
      <div
        style={{ display: "flex", marginTop: 20, justifyContent: "space-around" }}
      >
        <button onClick={onCancel} className="boxCancelBtn text">
          {cancelText}
        </button>
        {
          isLoading ?
            <div className="spinnerContainer">
              <Spinner color={'black'} loading={isLoading} size={20} />
            </div>
            :
            <button onClick={onConfirm} className="boxDelBtn text" id="para1">
              {rightBtnText}
            </button>
        }
      </div>
    </div>
  );
};

ConfirmationContent.T = {
  text: T.string,
  title: T.string,
  content: T.string,
  subContent: T.string,
  onCancel: T.func,
  onConfirm: T.func,
  cancelText: T.func,
  titleClass: T.string,
};

ConfirmationContent.defaultProps = {
  rightBtnText: "DELETE",
  cancelText: "CANCEL",
  titleClass: "boxTitle",
};
